import gsap from 'gsap'

export default class SliderDescription {
  constructor(el) {
    this.el = el
    this.slides = [...el.querySelectorAll('.slider-description--slide')]
    this.cards = [...el.querySelectorAll('.slider-description--card-item')]
    this.prevBtn = el.querySelector('.slider-description--arrow.prev')
    this.nextBtn = el.querySelector('.slider-description--arrow.next')
    this.current = 0
    this.animating = false

    if (!this.slides.length) return

    this.init()
    this.bindEvents()
  }

  init() {
    requestAnimationFrame(() => this.setStates(false))
  }

  get isMobile() {
    return window.matchMedia('(max-width: 991px)').matches
  }

  setStates(animate = true) {
    const total = this.slides.length
    const behind = (this.current - 1 + total) % total
    const mobile = this.isMobile

    this.slides.forEach((slide, i) => {
      const isActive = i === this.current
      const isBehind = i === behind

      const props = isActive
        ? { scale: 1, opacity: 1, zIndex: 2, xPercent: 0, yPercent: 0 }
        : isBehind
          ? mobile
            ? { scale: 0.9, opacity: 0.4, zIndex: 1, xPercent: 0, yPercent: -10 }
            : { scale: 0.9, opacity: 0.4, zIndex: 1, xPercent: -15, yPercent: 10 }
          : mobile
            ? { scale: 0.9, opacity: 0, zIndex: 0, xPercent: 0, yPercent: -10 }
            : { scale: 0.9, opacity: 0, zIndex: 0, xPercent: -15, yPercent: 10 }

      if (animate) {
        gsap.to(slide, { ...props, duration: 0.65, ease: 'power3.inOut' })
      } else {
        gsap.set(slide, props)
      }
    })
  }

  bindEvents() {
    this.nextBtn?.addEventListener('click', () => this.go(1))
    this.prevBtn?.addEventListener('click', () => this.go(-1))
  }

  go(dir) {
    if (this.animating) return
    this.animating = true

    const total = this.slides.length
    const leaving = this.slides[this.current]

    this.current = (this.current + dir + total) % total

    const tl = gsap.timeline({ onComplete: () => { this.animating = false } })

    if (this.isMobile) {
      tl.to(leaving, { yPercent: dir === 1 ? 110 : -110, xPercent: 0, opacity: 0, scale: 0.9, zIndex: 0, duration: 0.55, ease: 'power3.inOut' }, 0)
    } else {
      tl.to(leaving, { xPercent: dir === 1 ? -110 : 110, yPercent: 0, opacity: 0, scale: 0.9, zIndex: 0, duration: 0.55, ease: 'power3.inOut' }, 0)
    }

    tl.add(() => this.setStates(true), 0)

    this.syncCard()
  }

  syncCard() {
    this.cards.forEach((card, i) => {
      const isActive = i === this.current
      card.classList.toggle('is-active', isActive)

      if (isActive) {
        const els = [...card.querySelectorAll('.slider-description--card-title, .slider-description--card-text')]
        gsap.fromTo(els,
          { opacity: 0, y: 18 },
          { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out', stagger: 0.1, delay: 0.25 }
        )
      }
    })
  }
}
